import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const initFooter = () => {
	if (window.innerWidth < 1024) return;

	const footer = document.getElementById("footer");

	if (footer) {
		const footerInner = footer.querySelector(".footer-inner");

		gsap.set(footerInner, { y: "-50%", opacity: 1 });

		ScrollTrigger.create({
			trigger: footer,
			start: "top bottom",
			end: "bottom bottom",
			scrub: true,
			invalidateOnRefresh: true,
			onUpdate: (self) => {
				const progress = self.progress;
				const yValue = -50 * (1 - progress);
				gsap.set(footerInner, {
					y: `${yValue}%`,
				});
			},
		});
	}
};

export default initFooter;
